<div class="dashboard-layout">
  <!-- Sidebar -->
  <aside class="sidebar shadow">
    <div class="sidebar-header p-3 d-flex align-items-center">
      <svg width="24" height="24" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" class="me-2">
        <path d="M20 2L35.5885 11V29L20 38L4.41154 29V11L20 2Z" stroke="white" stroke-width="2.5"/>
        <circle cx="20" cy="20" r="4" fill="#d59448"/>
      </svg>
      <span class="brand-name fw-bold text-white">SUPPLY<span class="text-gold">VALID</span></span>
    </div>

    <nav class="sidebar-nav mt-3">
      <ul class="list-unstyled">
        <li class="nav-item px-3 py-2" [routerLink]="['/dashboard']" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
          <i class="pi pi-home me-2"></i> Dashboard
        </li>
        <li class="nav-item px-3 py-2" [routerLink]="['/dashboard/users']" routerLinkActive="active">
          <i class="pi pi-users me-2"></i> Users
        </li>
        <li class="nav-item px-3 py-2" [routerLink]="['/dashboard/profile']" routerLinkActive="active">
          <i class="pi pi-user me-2"></i> Profile
        </li>
        <li class="nav-item px-3 py-2" [routerLink]="['/dashboard/roles']" routerLinkActive="active">
          <i class="pi pi-key me-2"></i> Roles
        </li>
        
        <!-- Master Menu -->
        <li class="nav-item px-3 py-2" (click)="toggleMasterMenu()">
          <div class="d-flex justify-content-between align-items-center w-100">
            <span><i class="pi pi-database me-2"></i> Master</span>
            <i class="pi" [ngClass]="masterMenuOpen ? 'pi-chevron-down' : 'pi-chevron-right'" style="font-size: 0.7rem;"></i>
          </div>
        </li>
        <li *ngIf="masterMenuOpen" class="submenu">
          <ul class="list-unstyled">
            <li class="nav-item ps-5 pe-3 py-2" [routerLink]="['/dashboard/master/clients']" routerLinkActive="active">
              Clients
            </li>
            <li class="nav-item ps-5 pe-3 py-2" [routerLink]="['/dashboard/master/roles']" routerLinkActive="active">
              Roles
            </li>
            <li class="nav-item ps-5 pe-3 py-2" [routerLink]="['/dashboard/master/users']" routerLinkActive="active">
              Users
            </li>
          </ul>
        </li>

        <li class="nav-item px-3 py-2">
          <i class="pi pi-cog me-2"></i> Settings
        </li>
      </ul>
    </nav>

    <div class="sidebar-footer mt-auto p-3">
      <button class="btn btn-link text-white text-decoration-none p-0 w-100 text-start d-flex align-items-center" (click)="onLogout()">
        <i class="pi pi-power-off me-2"></i> Logout
      </button>
    </div>
  </aside>

  <!-- Main Content -->
  <main class="main-content">
    <header class="content-header p-3 bg-white shadow-sm d-flex justify-content-between align-items-center">
      <h5 class="m-0 fw-semibold text-dark">Intelligence Dashboard</h5>
      <div class="user-profile d-flex align-items-center">
        <span class="me-2 small fw-medium">{{ userName }}</span>
        <i class="pi pi-user-circle" style="font-size: 1.5rem"></i>
      </div>
    </header>

    <div class="content-body p-4">
      <!-- Stats Row - Only visible on Dashboard Home -->
      <div class="row mb-4" *ngIf="isDashboardHome()">
        <div class="col-md-3">
          <div class="card border-0 shadow-sm stats-card" (click)="navigateToUsers()">
            <div class="card-body d-flex align-items-center">
              <div class="stats-icon bg-primary-soft text-primary me-3">
                <i class="pi pi-users" style="font-size: 1.5rem;"></i>
              </div>
              <div>
                <h6 class="text-muted mb-1 small text-uppercase fw-bold">Total Users</h6>
                <h3 class="m-0 fw-bold text-dark">{{ totalUsers }}</h3>
              </div>
            </div>
          </div>
        </div>
      </div>

      <router-outlet></router-outlet>
    </div>
  </main>
</div>
